import { render, staticRenderFns } from "./ReservationRegisterTab.vue?vue&type=template&id=f56f61e8&scoped=true&lang=pug"
import script from "./ReservationRegisterTab.vue?vue&type=script&lang=ts"
export * from "./ReservationRegisterTab.vue?vue&type=script&lang=ts"
import style0 from "./ReservationRegisterTab.vue?vue&type=style&index=0&id=f56f61e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56f61e8",
  null
  
)

export default component.exports